import gql from 'graphql-tag';

export const GET_TERRITORY_TEAM = gql`
	query GetTerritoryTeam {
		getTerritoryTeam {
			territoryName
			division
			members {
				name
				email
			}
		}
	}
`;
